// Removed import from @shared/documents
import { useNavigate } from 'react-router-dom';

import { useAuth } from '../../hooks/useAuth';
import useFetch from '../../hooks/useFetch';
import useSimpleMutation from '../../hooks/useSimpleMutation';
import { extractErrorMessage } from '../../utils/errorHandling';
import {
	ErrorMessage,
	LoadingGif,
	LoadingMessage,
} from '../Shared/CommonStyles';

import * as S from './Avisos.styles';

// Define the type locally
interface AvisDocument {
	_id: string;
	content: string;
}

//TODO Millorar useSimpleMutation per tal que no faci faltar fer servir useState en casos com aquest

const Avisos = () => {

	const { user } = useAuth();
	const navigate = useNavigate();

	const isAuthenticated =
		!!user &&
		(user.roles.includes('Admin') || user.roles.includes('Agrupament'));

	const {
		data: avisos,
		isLoading: isFetchingAvisos,
		error: fetchAvisosError,
	} = useFetch<AvisDocument[]>({
		queryKey: ['avisos'],
		url: '/api/avisos/',
	});

	const deleteMutation = useSimpleMutation<string>({
		method: 'delete',
		url: (data) => `/api/avisos/${data}`,
		queriesToInvalidate: [['avisos']],
		navigateUrl: '/inici',
	});

	const handleDeleteClick = (id: string) => {
		if (window.confirm("Segur que vols eliminar l'avis?")) {
			deleteMutation.mutate(id);
		}
	};

	const handleEditClick = (id: string) => {
		navigate(`/avisos/${id}/editar`);
	};

	const linkify = (text: string) => {
		const urlRegex =
			/(\bhttps?:\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/gi;

		return text.split(urlRegex).map((part, index) => {
			if (part.match(urlRegex)) {
				return (
					<a
						key={index}
						href={part}
						target="_blank"
						rel="noopener noreferrer"
					>
						{part}
					</a>
				);
			}
			return part;
		});
	};

	const loading = isFetchingAvisos;
	const error = fetchAvisosError;

	return loading ? (
		<LoadingMessage>
			<LoadingGif size="large" />
		</LoadingMessage>
	) : error ? (
		<ErrorMessage>Error: {extractErrorMessage(error)}</ErrorMessage>
	) : avisos && avisos.length > 0 ? (
		<S.AvisosContainer>
			{avisos.map((avis) => (
				<S.Avis key={avis._id}>
					<p>
						<strong>Avís:</strong> {linkify(avis.content)}
					</p>
					{isAuthenticated && (
						<S.ButtonsContainer>
							<S.ActionButton onClick={() => handleDeleteClick(avis._id)}>
								Eliminar
							</S.ActionButton>
							<S.ActionButton onClick={() => handleEditClick(avis._id)}>
								Editar
							</S.ActionButton>
						</S.ButtonsContainer>
					)}
				</S.Avis>
			))}
		</S.AvisosContainer>
	) : avisos && avisos.length === 0 ? (
		<></>
	) : (
		<ErrorMessage>No s&apos;han pogu carregar els avisos</ErrorMessage>
	);
};

export default Avisos;
